import * as React from 'react';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

export default class VehicleNumberStatus extends React.Component<GridCustomCellProps> {
  render() {
    if (!this.props.field) return null;

    switch (this.props.dataItem.Status) {
      case 'In Service':
          return <td {...this.props.tdProps} className='inservice' title={this.props.dataItem.Status}>{this.props.dataItem.VehicleNumber}</td>;
      case 'On A Load':
          return <td {...this.props.tdProps} className='onaload' title={this.props.dataItem.Status}>{this.props.dataItem.VehicleNumber}</td>;
      case 'Out Of Service':
          return <td {...this.props.tdProps} className='outofservice' title={this.props.dataItem.Status}>{this.props.dataItem.VehicleNumber}</td>;
      case 'Unconfirmed In Service':
          return <td {...this.props.tdProps} className='unconfirmedinservice' title={this.props.dataItem.Status}>{this.props.dataItem.VehicleNumber}</td>;
    }
    return <td {...this.props.tdProps} title={this.props.dataItem.Status}>{this.props.dataItem.VehicleNumber}</td>;
  }
}
